import { render, staticRenderFns } from "./UsersCustomerCenter.vue?vue&type=template&id=2431847c&"
import script from "./UsersCustomerCenter.vue?vue&type=script&lang=ts&"
export * from "./UsersCustomerCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports